import React from "react";

interface IProps {
	spot: number;
	className?: string;
}

export const Available = ({ spot, className }: IProps) => (
	<span className={className}>
		{spot > 5 && "ÚLTIMAS VAGAS"}
		{spot <= 5 && spot > 1 && `restam ${spot} vagas`}
		{spot === 1 && `resta ${spot} vaga`}
	</span>
);
